// extracted by mini-css-extract-plugin
export default {"container":"loading-planos_container__QIrP2","loading":"loading-planos_loading__8a7De"};